import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    isNew: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    validation() {
      return !!this.proxy.title && !!this.proxy.OwnerId
    }
  },

  watch: {
    validation(value) {
      this.$emit('validation', value)
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  render
}
